import { IAppState } from '../../redux';

export const selectTariffId = (state: IAppState) => {
  return state.publishTerms?.publication.period?.tariffIdentificator.tariffId;
};
